window.Simplemail = {
	loadPrefs : function(){
		var options = {
			title	: Loc.g("Préférences Simple Mail"),
			buttons	: [
                { text: Loc.g("Fermer"), class: 'btn btn-default', click : function(){MyWindow.close();}},
                { text: Loc.g("Enregistrer"), class: 'btn btn-primary', click : function(){$('#smpForm').submit()}}
			],
			callback	: function(){Simplemail.preparePrefsForm();Simplemail.prepareSyncForm();},
			width: 500
		};
		
		var fileOpt = {action:""};
		MyWindow.load("simplemail_prefs", fileOpt, options);
	},
	
	preparePrefsForm : function(){
		var formId = "smpForm";
		var options = {
			success:function(data){Simplemail.recordCallback(data);}, 
			dataType:"json"
		};
		MyForm.prepare(formId, "simplemail_prefs&action=record", options, true);
		MyFacture.initEvent("#"+formId);
	},
	
	recordCallback : function(data){
		var formIsOk = MyForm.processJson(data, "smpForm", "popupWindow");
		
		var fileOpt = {action:""};
		$("#smp_defaultList").empty();

		if(data.smpError.length != 0){
			MyWindow.alert(data.mjError.message, {type: 'error'});
			$('#smpLists').fadeOut();
			$('#smSyncForm').fadeOut();
		}else{
			var opts = '';
			for(var i = 0; i < data.simplemailLists.length; i++){
				var list = data.simplemailLists[i];
				opts += '<option value="'+list.id+'">'+list.name+'</option>';
			}
			if($('tr.login').length > 0){
				var APIKey = $('#smp_apiKey').val();
				$('tr.login').remove();
				$('#smp_apiSecret').val(data.simplemailUser.user_key);
				$('#smpForm table').prepend('<tr>'
											+'<td>Clé d\'API</td>'
											+'<td>'
											+APIKey
											+'<input type="hidden" name="smp_apiKey" id="smp_apiKey" class="WBig" value="'+APIKey+'" />'
											+'</td>'
											+'</tr>'
											+'<tr>'
											+'<td colspan="2">Connecté en temps que '+data.simplemailUser.first_name+' '+data.simplemailUser.last_name+' ('+data.simplemailUser.email+')'
											+'</tr>'
											+'');
			}
			$('#smpLists td:last').html('<select name="smp_defaultList" id="smp_defaultList">'+opts+'</select>');
			$('#smpLists').fadeIn(300, function(){MyFacture.customForm();});
			$('#smSyncForm').fadeIn(300, function(){MyFacture.customForm();});
			Simplemail.preparePrefsForm();
		}
	},
	
	prepareSyncForm : function(){
		var formId = "smSyncForm";
		var options = {success:function(data){Simplemail.syncCallback(data);}, dataType:"json"};
		MyForm.prepare(formId, "simplemail_sync&action=allContacts", options, true);
		MyFacture.initEvent("#"+formId);
		MyFacture.customForm("#"+formId);
	},
	
	syncCallback : function(data){
		if(data.smError.length != 0){
			MyWindow.alert(data.smError.message, {type: 'error'});
		} else {
			MyWindow.alert(Loc.g("Contacts synchronisés!"), {type: "confirm"});
		}
		
		MyWindow.awake();
		MyWindow.enable();
	}
};